import createReactComponent from '../createReactComponent';
export default createReactComponent('antenna-bars-2', 'IconAntennaBars2', [
  ['path', { d: 'M6 18l0 -3', key: 'svg-0' }],
  ['path', { d: 'M10 18l0 .01', key: 'svg-1' }],
  ['path', { d: 'M14 18l0 .01', key: 'svg-2' }],
  ['path', { d: 'M18 18l0 .01', key: 'svg-3' }],
]);
